export default "__VITE_PUBLIC_ASSET__f4b93c8f__"